/**
 * getRequestPageSize determines how many items will need to be retrieved to complete the current page of data
 * @param dataLength - the length of the currently loaded list of data
 * @param pageIndex
 * @param pageSize
 */
export const getRequestPageSize = (dataLength: number, pageIndex: number, pageSize: number) => {
  const startIndex = pageIndex * pageSize;
  const endIndex = startIndex + pageSize;
  return endIndex - dataLength;
};
